import { create } from "zustand";

interface SelectAssetsState {
  selectedAssets: string[];
  setSelectedAssets: (assetIds: string[]) => void;
}

export const useSelectAssetsStore = create<SelectAssetsState>((set) => ({
  selectedAssets: [],
  setSelectedAssets: (assetIds) => set((state) => ({
    selectedAssets: [...assetIds]
  })),
}));